import { mspRoutes, customerRoutes } from "./routes";

import modules from "./store";

import { NAV_ITEMS_MODE } from "@/constants";
import { MSP_NAV_ITEMS, CUSTOMER_NAV_ITEMS } from "./constants";

const SettingsModule = ({ _app, router, store, registerNavItems }) => {
  // Routes
  router.addRoute(mspRoutes);
  router.addRoute(customerRoutes);
  // Stores
  store.registerModule("sso", modules.sso);

  // Nav Items
  registerNavItems(NAV_ITEMS_MODE.MSP, MSP_NAV_ITEMS);
  registerNavItems(NAV_ITEMS_MODE.CUSTOMER_ADMIN, CUSTOMER_NAV_ITEMS);
};

export { SettingsModule };

export default {};
